import { Spacer, Typo } from 'components/ui-kit';
import { MoneyFormatter } from 'lib';
import { Aside } from 'modules/cart/components/cart-page/components/aside';
import { AsideInfoLine } from 'modules/cart/components/cart-page/components/aside/components';
import { CartPositions } from 'modules/cart/components/checkout/component';
import { EmployeeNotice } from 'modules/cart/components/common';
import { useCartContext } from 'modules/cart/providers';
import { useUserInfoContext } from 'providers/auth-provider/user-info-provider';
import styles from './final-price-aside.module.scss';
import { useDeliveryTypeContext } from '../offer-form/components/delivery-price-provider.component';

export const finalPriceAsideTestSelectors = {
  finalPriceAsideTotal: 'final-price-aside-total',
  finalPriceAsideDeliveryType: 'final-price-aside-delivery-type',
  finalPriceAsideDelivery: 'final-price-aside-delivery',
  finalPriceAsideProducts: 'final-price-aside-products',
};
export const FinalPriceAside = (): JSX.Element | null => {
  const { cart } = useCartContext();
  const { delivery } = useDeliveryTypeContext();
  const { profile } = useUserInfoContext();

  if (
    !cart ||
    !cart.positionTotalPrice?.priceValue ||
    !cart.totalPrice?.priceValue
  )
    return null;

  const finalPrice =
    cart.totalPrice.priceValue + (Number(delivery?.priceValue) || 0);

  return (
    <Aside title="Общая стоимость">
      <AsideInfoLine
        left="Товары"
        right={MoneyFormatter.format(cart.totalPrice.totalPrice ?? 0)}
      />
      <Spacer size={16} />

      {delivery && (
        <>
          <AsideInfoLine
            left={
              <span
                data-at={
                  finalPriceAsideTestSelectors.finalPriceAsideDeliveryType
                }
              >
                {delivery.previewText}
              </span>
            }
            right={
              <span
                data-at={finalPriceAsideTestSelectors.finalPriceAsideDelivery}
              >
                {MoneyFormatter.format(Number(delivery.priceFull))}
              </span>
            }
          />
        </>
      )}
      {!!cart.positionTotalPrice.discountPriceValue && (
        <>
          <Spacer size={16} />
          <AsideInfoLine
            left="Скидки по акциям"
            right={
              <Typo color="accent" variant="l" weight="500">
                —
                {MoneyFormatter.format(cart.totalPrice.discountPriceValue ?? 0)}
              </Typo>
            }
          />
        </>
      )}

      <Spacer size={16} />
      <AsideInfoLine
        variant="xl"
        left="Итого"
        right={
          <span data-at={finalPriceAsideTestSelectors.finalPriceAsideTotal}>
            {MoneyFormatter.format(finalPrice)}
          </span>
        }
      />
      <EmployeeNotice profile={profile} className={styles.employeeNotice} />

      <Spacer size={16} />
      <CartPositions positions={cart.positions} />
    </Aside>
  );
};
